import { render, staticRenderFns } from "./AccountManage.vue?vue&type=template&id=3536bb9b&scoped=true&"
import script from "./AccountManage.vue?vue&type=script&lang=js&"
export * from "./AccountManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3536bb9b",
  null
  
)

export default component.exports